<template>
  <div class="container mescroll-touch">
    <img src="../../assets/images/musicicon.png" class="muimg icon-spin" :class="{ 'paused': !isRotating }"
      @click="toggleRotate" />
    <!-- <audio src="../../assets/music/music.mp3" controls></audio> -->
    <img src="../../assets/images/bjtitle.png" class="guanggaoimg" />
    <!-- <el-carousel :interval="5000" arrow="always" class="elbanner">
      <el-carousel-item v-for="item in bannerlist" :key="item">
        <img :src="item.ImgUrl" class="bannerimg" @click="jumpimgurl(item.LinkUrl, item.Id, item.Description)" />
      </el-carousel-item>
    </el-carousel> -->
    <div class="btnlist">
      <div class="btnrow">
        <div class="btn50 left50" @click="gowelcome()">
          <img src="../../assets/images/bjwelcome.png" class="btnimg" alt="">
        </div>
        <div class="btn50" @click="gozhuanjia()">
          <img src="../../assets/images/bjzhuanjia.png" class="btnimg" alt="">
        </div>
      </div>

      <div class="btnrow">
        <div class="btn25outleft">
          <div class="btn25" @click="gojiansuo()">
            <img src="../../assets/images/bjcheck.png" class="btnimg" alt="">
          </div>
          <div class="btn25" @click="godaohang()">
            <img src="../../assets/images/bjdaohang.png" class="btnimg" alt="">
          </div>
        </div>
        <div class="btn50" @click="gomeeting()">
          <img src="../../assets/images/bjricheng.png" class="btnimg" alt="">
        </div>
        <div class="btn25outright">
          <div class="btn25" @click="gozhibo()">
            <img src="../../assets/images/bjzhibo.png" class="btnimg" alt="">
          </div>
          <div class="btn25" @click="goxiangce()">
            <img src="../../assets/images/bjxiangce.png" class="btnimg" alt="">
          </div>
        </div>
      </div>

      <div class="btnrow">
        <div class="btn50 left50" @click="goinfo()">
          <img src="../../assets/images/bjinfo.png" class="btnimg" alt="">
        </div>
        <div class="btn50" @click="gocontact()">
          <img src="../../assets/images/bjcontact.png" class="btnimg" alt="">
        </div>
      </div>
    </div>

    <div class="tcout" v-if="showtc == 1">
      <div class="tcimg">
        <div class="jumptc">
          <img src="../../assets/images/bjtuiguang.png" class="tcimgin" />
        </div>
        <div class="close" @click="closebtn()">
          <img src="../../assets/images/tcclose.png" class="tcimgin" />
        </div>
      </div>

      <div class="back"></div>
    </div>
  </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
import music from '../../assets/music/music.mp3'
export default {
  name: 'BJZL',
  data() {
    return {
      day: 0,
      hh: 0,
      mm: 0,
      ss: 0,
      list: {},
      showtc: 0,
      isopen: 0,
      bannerlist: [],
      isRotating: false,
      audio: null,
      isPlaying: false,
      hasUserInteracted: false
    }
  },
  mixins: [mixin],
  components: {
  },
  created() {
    this.initbjShare();
    this.getimg()
    document.title = "第九届北京肿瘤防治研究会年会暨第十九届绿荫沙龙学术年会";
  },
  // mounted() {
  //   this.audio = new Audio()
  //   this.audio.src = music
  //   this.audio.loop = true
  // },
  // mounted() {
  //   this.audio = new Audio(music);
  //   this.audio.loop = true;
  //   this.audio.muted = true; // 关键：静音可自动播放
  //   this.audio.play().catch(e => console.warn('静音自动播放失败:', e));

  //   // 监听用户首次交互，解除静音
  //   const enableSound = () => {
  //     this.audio.muted = false;
  //     document.removeEventListener('click', enableSound);
  //     document.removeEventListener('touchstart', enableSound);
  //   };

  //   document.addEventListener('click', enableSound);
  //   document.addEventListener('touchstart', enableSound);
  // },
  mounted() {
    this.initAudio();
  },
  beforeDestroy() {
    if (this.audio) {
      this.audio.pause()
      this.audio = null
    }
  },
  methods: {
    gotcurl(u, id, d) {
      if (u) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: d,
            TCode: 'activity_link',
            Rid: id,
          },)
          .then((res) => {
            window.location.href = u;
          });
      }
    },
    getimg() {
      let that = this;
      let isClose = sessionStorage.getItem("acmedLinkClose");
      if (!isClose) {
        this.$axios
          .post("/api/api/web/activity/GetActivityLink", {
            Code: "ACMEDIndex",
          })
          .then((res) => {
            // console.log(res.data.Data)
            if (res.Data.length > 0) {
              that.showtc = 1;
              that.list = res.Data[0];
            } else {
              that.showtc = 0;
            }
            // console.log(this.list)
          });
      }
    },
    gowelcome() {
      this.$router.push({ name: 'bjwelcome' })
    },
    gozhuanjia() {
      this.$router.push({ name: 'bjzhuanjia' })
    },
    goinfo() {
      this.$router.push({ name: 'bjinfo' })
    },
    gocontact() {
      this.$router.push({ name: 'bjcontact' })
    },
    godaohang() {
      this.$router.push({ name: 'bjdaohang' })
    },
    gozb() {
      // this.$router.push({ name: 'ccdszhibo' })
      window.location.href = "https://www.pailixiang.com/m/album/main_ig99041521.html"
    },
    gojiansuo() {
      this.$router.push({ name: 'bjjiansuo' })
    },
    gomeeting() {
      this.$router.push({ name: 'bjlist' })
    },
    goToExternalLink() {
      window.location.href = 'https://mp.weixin.qq.com/s/q0HTpYzezGgwvYKXciYOtw';
    },
    goxiangce() {
      window.location.href = 'https://live.photoplus.cn/live/29520877'
    },
    gozhibo() {
      window.location.href = 'https://h5.iooo.net/2025/zlfz_rc_251225/'
    },
    closebtn() {
      this.showtc = 0;
      sessionStorage.setItem("acmedLinkClose", "1");
    },
    jumpimgurl(url, id, d) {
      if (url) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: d,
            TCode: 'activity_banner',
            Rid: id,
          })
          .then((res) => {
            window.location.href = url;
          });
      }
    },
    isWechat() {
      return /MicroMessenger/i.test(navigator.userAgent);
    },
    initAudio() {
      this.audio = new Audio(music);
      this.audio.loop = true;

      // ===== 微信环境：使用 WeixinJSBridgeReady =====
      if (this.isWechat()) {
        const playInWechat = () => {
          // 尝试直接播放（微信通常允许）
          this.audio.play()
            .then(() => {
              this.isPlaying = true;
              this.isRotating = true;
            })
            .catch(e => {
              console.warn('微信中播放失败，回退到静音模式:', e);
              this.fallbackToMutedPlay();
            });
        };

        if (typeof WeixinJSBridge !== 'undefined') {
          // 如果已就绪，立即播放
          playInWechat();
        } else {
          // 等待就绪
          document.addEventListener('WeixinJSBridgeReady', playInWechat, { once: true });
        }
      }
      // ===== 非微信环境：静音预加载 + 等待用户交互 =====
      else {
        this.fallbackToMutedPlay();
      }
    },
    fallbackToMutedPlay() {
      // 静音播放（可绕过部分限制）
      this.audio.muted = true;
      this.audio.play().catch(() => {
        // 即使静音也可能失败（如严格策略），但没关系，等点击
      });

      // 用户首次交互时取消静音并恢复播放状态
      const enableSound = () => {
        if (!this.hasUserInteracted) {
          this.audio.muted = false;
          this.hasUserInteracted = true;

          // 如果之前是“想播放但被阻止”，现在可以真正播放
          if (!this.isPlaying) {
            this.audio.play().catch(console.warn);
            this.isPlaying = true;
            this.isRotating = true;
          }

          document.removeEventListener('click', enableSound);
          document.removeEventListener('touchstart', enableSound);
        }
      };

      document.addEventListener('click', enableSound, { once: true });
      document.addEventListener('touchstart', enableSound, { once: true });
    },
    toggleRotate() {
      if (!this.audio) return;

      this.isRotating = !this.isRotating;
      this.isPlaying = !this.isPlaying;

      if (this.isPlaying) {
        // 播放前确保非静音（尤其非微信环境）
        this.audio.muted = false;
        this.audio.play().catch(e => {
          console.warn('播放被阻止:', e);
          // 可选：提示用户“请点击页面以启用声音”
        });
      } else {
        this.audio.pause();
      }
    },
    // toggleRotate() {
    //   this.isRotating = !this.isRotating;
    //   if (this.isPlaying) {
    //     this.audio.pause()
    //   } else {
    //     this.audio.play().catch(e => {
    //       console.warn('自动播放被阻止:', e)
    //     })
    //   }
    //   this.isPlaying = !this.isPlaying
    // }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  width: 100%;
  // background: rgb(228, 236, 255);
  position: relative;
}

.img {
  display: block;
  width: 100%;
  margin-bottom: .2rem
}

.guanggaoimg {
  display: block;
  width: 100%;
  margin: auto;
  margin-bottom: .2rem;
  // padding-top: 0.3rem;
}

.btnlist {
  display: flex;
  flex-direction: column;
  width: 92%;
  margin: auto;
}

.btnrow {
  display: flex;
  flex-direction: row;
  // margin-bottom: .2rem;
}

.btnmiddle {
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  width: 33%;
  border-radius: 5px;
  padding: .2rem 0;
  box-shadow: -1px 1px 1px 1px rgba(0, 0, 0, 0.1);
  margin-right: .2rem;
  display: flex;
  flex-direction: column;
}

.btnmiddleleft {
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  width: 33%;
  border-radius: 5px;
  padding: .3rem 0;
  box-shadow: -1px 1px 1px 1px rgba(0, 0, 0, 0.1);
  margin-left: .2rem;
}

.btnmimg {
  display: block;
  width: 22%;
  margin: auto;
  margin-right: 10%;
}

.btnimgout {
  text-align: right;
  width: 100%;
}

.btntext {
  display: block;
  width: 100%;
  font-size: .4rem;
  color: #ffd7c0;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 10%;
}

.btnlarge {
  display: flex;
  flex-direction: column;
  width: 66%;
  background-image: linear-gradient(to right, #003583, #003bb9);
  box-shadow: 0 0.026667rem 0.133333rem 0 rgba(0, 0, 0, 0.1);
  border-radius: 0.133333rem;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0;
}

.left50 {
  margin-right: 2%
}

.btn50 {
  display: flex;
  flex-direction: column;
  width: 50%;
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0;
}

.btn25outleft {
  display: flex;
  flex-direction: column;
  width: 24%;
  margin-right: 1%;
  justify-content: space-between;
  padding: 0.2rem 0;
}

.btn25outright {
  display: flex;
  flex-direction: column;
  width: 24%;
  margin-left: 1%;
  justify-content: space-between;
  padding: 0.2rem 0;
}

.btn111 {
  display: flex;
  flex-direction: row;
  width: 100%;
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0;
}

.btnmimg1 {
  display: block;
  width: 11%;
  margin: auto;
  margin-right: 5%;
}

.btnmimg2 {
  display: block;
  width: 14%;
  margin: auto;
  margin-right: 7%;
}

.btnmimg111 {
  display: block;
  width: 21%;
  margin: auto;
  margin-right: 13%;
}

.btntext1 {
  display: block;
  width: 100%;
  font-size: .4rem;
  color: #ffd7c0;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 5%;
}

.btntext2 {
  display: block;
  width: 100%;
  font-size: .4rem;
  color: #ffd7c0;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 7%;
}

.btntext111 {
  display: block;
  width: 100%;
  font-size: .4rem;
  color: #ffd7c0;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 4%;
}

.btnincol {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0;
  top: 0;
  justify-content: space-between;
  height: 100%;
}

.btnsmall {
  display: flex;
  flex-direction: row;
  width: 100%;
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.11rem 0;
  position: relative;
  margin-top: 0.1rem;
}

.btnsmall1 {
  display: flex;
  flex-direction: row;
  width: 100%;
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  // padding: 0.18rem 0;
}

.btnsmall2 {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.05rem 0;
  // position: absolute;
  // left: 0;
  // top: 0;
  color: #ffd7c0;
  // font-weight: bold;
}

.timem {
  font-size: .4rem;
}

.times {
  font-size: .4rem;
}

.timel {
  font-size: 0.6rem;
  font-weight: bold;
}

.btnsimple {
  position: relative;
  width: 100%;
}

.btnincolnew {
  position: unset;
}

.btnheng {
  flex-direction: row;
}

.tcout {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 20;

  .tcimg {
    display: block;
    width: 80%;
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%);
    z-index: 30;

    .close {
      width: 1rem;
      height: 1rem;
      display: block;
      margin: auto;
      margin-top: 0.2rem;
    }

    img {
      display: block;
      width: 100%;
    }
  }

  .back {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 25;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
  }
}

// .jumptc {}

.btnhide {
  opacity: 0;
  font-size: .2rem;
}

.btnhide1 {
  opacity: 0;
  font-size: .8rem;
}

.bold {
  display: inline-block;
  font-weight: bold;
}

.bannerimg {
  width: 100%;
  display: block;
}

.elbanner {
  position: relative;
  height: 4.15rem;
  width: 93%;
  margin: auto;
  overflow: hidden;
  padding-top: .3rem;
}

::v-deep .el-carousel__container {
  height: 100%;
}

::v-deep .el-carousel__indicators--horizontal {
  bottom: 5%;
}

.btnimg {
  width: 100%;
  display: block;
}

.muimg {
  position: absolute;
  width: 0.9rem;
  right: 2%;
  top: 0.2rem;
}

.icon-spin {
  animation: rotate360 2.5s linear infinite;
}

.icon-spin.paused {
  animation-play-state: paused;
}


@keyframes rotate360 {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>